import axios from "axios";

// Global session expired callback - will be set by ErrorContext
let sessionExpiredCallback = null;

export const setSessionExpiredCallback = (callback) => {
  sessionExpiredCallback = callback;
};

// Create axios instance factory function that optionally accepts getToken
export const createAxiosInstance = (getToken = null) => {
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    timeout: 300000000
  });

  axiosInstance.interceptors.request.use(async function(config) {
    config.headers['x-api-key'] = process.env.REACT_APP_PUBLIC_API_KEY;
    config.headers['ngrok-skip-browser-warning'] = 'true';

    // let token = null;
    // if (getToken) {
    //   try {
    //     token = await getToken({template: 'talenthunt'});
    //   } catch (error) {
    //     console.warn('Failed to get Clerk token:', error);
    //   }
    // }

    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // } else {
      // Using legacy token from localStorage
      const legacyToken = localStorage.getItem('token');
      if (legacyToken) {
        config.headers.Authorization = `Bearer ${legacyToken}`;
      }
    // }

    return config;
  });

  // Add response interceptor for 401/403 errors
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        // Don't redirect to home for job details - let the component handle it
        const isJobDetailsRequest = error.config?.url?.includes('/opportunities/') && error.config?.url?.match(/\/opportunities\/\d+$/);

        // Check if we just received a fresh token from OAuth (within last 5 seconds)
        const freshTokenTime = sessionStorage.getItem('freshTokenReceived');
        const isFreshToken = freshTokenTime && (Date.now() - parseInt(freshTokenTime)) < 5000;

        if (!isJobDetailsRequest && !isFreshToken) {
          // Clear legacy token
          localStorage.removeItem('token');

          // Trigger session expired modal if callback is set
          if (sessionExpiredCallback) {
            sessionExpiredCallback();
          } else {
            // Fallback to alert if callback not set (shouldn't happen)
            if (!sessionStorage.getItem('shown403')) {
              window.alert('Your session has expired. Please log in again.');
              sessionStorage.setItem('shown403', 'true');
            }
            // Redirect to home
            if (window.location.pathname !== '/') {
              window.location.href = '/';
            }
          }
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

// For backward compatibility, create a default instance without Clerk token
const defaultAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  timeout: 300000000
});

defaultAxiosInstance.interceptors.request.use(function(config) {
  const legacyToken = localStorage.getItem('token');
  config.headers['x-api-key'] = process.env.REACT_APP_PUBLIC_API_KEY;
  config.headers['ngrok-skip-browser-warning'] = 'true';
  if (legacyToken) config.headers.Authorization = 'Bearer ' + legacyToken;
  return config;
});

// Add same response interceptor to default instance
defaultAxiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      const isJobDetailsRequest = error.config?.url?.includes('/opportunities/') && error.config?.url?.match(/\/opportunities\/\d+$/);

      // Check if we just received a fresh token from OAuth (within last 5 seconds)
      const freshTokenTime = sessionStorage.getItem('freshTokenReceived');
      const isFreshToken = freshTokenTime && (Date.now() - parseInt(freshTokenTime)) < 5000;

      if (!isJobDetailsRequest && !isFreshToken) {
        localStorage.removeItem('token');

        if (sessionExpiredCallback) {
          sessionExpiredCallback();
        } else {
          if (!sessionStorage.getItem('shown403')) {
            window.alert('Your session has expired. Please log in again.');
            sessionStorage.setItem('shown403', 'true');
          }
          if (window.location.pathname !== '/') {
            window.location.href = '/';
          }
        }
      }
    }
    return Promise.reject(error);
  }
);

export default defaultAxiosInstance;